/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopePlotAclAccessEntryDto,
  ApiEnvelopePlotAclActivityResponse,
  ApiEnvelopePlotAclBanDto,
  ApiEnvelopePlotAclBansResponse,
  ApiEnvelopePlotAclConfigDto,
  ApiEnvelopePlotAclDispatchDto,
  ApiEnvelopePlotAclEmptyDto,
  ApiEnvelopePlotAclOverviewDto,
  ApiEnvelopePlotAclPlotDto,
  ApiEnvelopePlotAclRankExemptionDto,
  ApiEnvelopePlotAclWhitelistDto,
  ApiEnvelopePlotAclWhitelistResponse,
  PlotAclAccessRequest,
  PlotAclActiveRequest,
  PlotAclBanRequest,
  PlotAclConfigRequest,
  PlotAclGetActivityParams,
  PlotAclNoteRequest,
  PlotAclPlotSettingsRequest,
  PlotAclRankExemptionRequest,
  PlotAclWhitelistRequest
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type plotAclGetConfigResponse200 = {
  data: ApiEnvelopePlotAclConfigDto
  status: 200
}

export type plotAclGetConfigResponseSuccess = (plotAclGetConfigResponse200) & {
  headers: Headers;
};
;

export type plotAclGetConfigResponse = (plotAclGetConfigResponseSuccess)

export const getPlotAclGetConfigUrl = (botId: string,) => {




  return `/api/plotacl/${botId}/config`
}

export const usePlotAclGetConfigHook = (): (botId: string, options?: RequestInit) => Promise<plotAclGetConfigResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string, options?: RequestInit) => {

        return customFetcher(getPlotAclGetConfigUrl(botId),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type plotAclUpsertConfigResponse200 = {
  data: ApiEnvelopePlotAclConfigDto
  status: 200
}

export type plotAclUpsertConfigResponseSuccess = (plotAclUpsertConfigResponse200) & {
  headers: Headers;
};
;

export type plotAclUpsertConfigResponse = (plotAclUpsertConfigResponseSuccess)

export const getPlotAclUpsertConfigUrl = (botId: string,) => {




  return `/api/plotacl/${botId}/config`
}

export const usePlotAclUpsertConfigHook = (): (botId: string,
    plotAclConfigRequest?: PlotAclConfigRequest, options?: RequestInit) => Promise<plotAclUpsertConfigResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    plotAclConfigRequest?: PlotAclConfigRequest, options?: RequestInit) => {

        return customFetcher(getPlotAclUpsertConfigUrl(botId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(plotAclConfigRequest)
  }
);
      }
  }


export type plotAclSetActiveResponse200 = {
  data: ApiEnvelopePlotAclDispatchDto
  status: 200
}

export type plotAclSetActiveResponseSuccess = (plotAclSetActiveResponse200) & {
  headers: Headers;
};
;

export type plotAclSetActiveResponse = (plotAclSetActiveResponseSuccess)

export const getPlotAclSetActiveUrl = (botId: string,) => {




  return `/api/plotacl/${botId}/active`
}

export const usePlotAclSetActiveHook = (): (botId: string,
    plotAclActiveRequest?: PlotAclActiveRequest, options?: RequestInit) => Promise<plotAclSetActiveResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    plotAclActiveRequest?: PlotAclActiveRequest, options?: RequestInit) => {

        return customFetcher(getPlotAclSetActiveUrl(botId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(plotAclActiveRequest)
  }
);
      }
  }


export type plotAclGetActivityResponse200 = {
  data: ApiEnvelopePlotAclActivityResponse
  status: 200
}

export type plotAclGetActivityResponseSuccess = (plotAclGetActivityResponse200) & {
  headers: Headers;
};
;

export type plotAclGetActivityResponse = (plotAclGetActivityResponseSuccess)

export const getPlotAclGetActivityUrl = (botId: string,
    params?: PlotAclGetActivityParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/plotacl/${botId}/activity?${stringifiedParams}` : `/api/plotacl/${botId}/activity`
}

export const usePlotAclGetActivityHook = (): (botId: string,
    params?: PlotAclGetActivityParams, options?: RequestInit) => Promise<plotAclGetActivityResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    params?: PlotAclGetActivityParams, options?: RequestInit) => {

        return customFetcher(getPlotAclGetActivityUrl(botId,params),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type plotAclGetBansResponse200 = {
  data: ApiEnvelopePlotAclBansResponse
  status: 200
}

export type plotAclGetBansResponseSuccess = (plotAclGetBansResponse200) & {
  headers: Headers;
};
;

export type plotAclGetBansResponse = (plotAclGetBansResponseSuccess)

export const getPlotAclGetBansUrl = (botId: string,) => {




  return `/api/plotacl/${botId}/bans`
}

export const usePlotAclGetBansHook = (): (botId: string, options?: RequestInit) => Promise<plotAclGetBansResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string, options?: RequestInit) => {

        return customFetcher(getPlotAclGetBansUrl(botId),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type plotAclAddBanResponse200 = {
  data: ApiEnvelopePlotAclBanDto
  status: 200
}

export type plotAclAddBanResponseSuccess = (plotAclAddBanResponse200) & {
  headers: Headers;
};
;

export type plotAclAddBanResponse = (plotAclAddBanResponseSuccess)

export const getPlotAclAddBanUrl = (botId: string,) => {




  return `/api/plotacl/${botId}/bans`
}

export const usePlotAclAddBanHook = (): (botId: string,
    plotAclBanRequest?: PlotAclBanRequest, options?: RequestInit) => Promise<plotAclAddBanResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    plotAclBanRequest?: PlotAclBanRequest, options?: RequestInit) => {

        return customFetcher(getPlotAclAddBanUrl(botId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(plotAclBanRequest)
  }
);
      }
  }


export type plotAclRemoveBanResponse200 = {
  data: ApiEnvelopePlotAclEmptyDto
  status: 200
}

export type plotAclRemoveBanResponseSuccess = (plotAclRemoveBanResponse200) & {
  headers: Headers;
};
;

export type plotAclRemoveBanResponse = (plotAclRemoveBanResponseSuccess)

export const getPlotAclRemoveBanUrl = (botId: string,
    banId: string,) => {




  return `/api/plotacl/${botId}/bans/${banId}`
}

export const usePlotAclRemoveBanHook = (): (botId: string,
    banId: string, options?: RequestInit) => Promise<plotAclRemoveBanResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    banId: string, options?: RequestInit) => {

        return customFetcher(getPlotAclRemoveBanUrl(botId,banId),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type plotAclSetBanNoteResponse200 = {
  data: ApiEnvelopePlotAclBanDto
  status: 200
}

export type plotAclSetBanNoteResponseSuccess = (plotAclSetBanNoteResponse200) & {
  headers: Headers;
};
;

export type plotAclSetBanNoteResponse = (plotAclSetBanNoteResponseSuccess)

export const getPlotAclSetBanNoteUrl = (botId: string,
    banId: string,) => {




  return `/api/plotacl/${botId}/bans/${banId}/note`
}

export const usePlotAclSetBanNoteHook = (): (botId: string,
    banId: string,
    plotAclNoteRequest?: PlotAclNoteRequest, options?: RequestInit) => Promise<plotAclSetBanNoteResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    banId: string,
    plotAclNoteRequest?: PlotAclNoteRequest, options?: RequestInit) => {

        return customFetcher(getPlotAclSetBanNoteUrl(botId,banId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(plotAclNoteRequest)
  }
);
      }
  }


export type plotAclGetWhitelistResponse200 = {
  data: ApiEnvelopePlotAclWhitelistResponse
  status: 200
}

export type plotAclGetWhitelistResponseSuccess = (plotAclGetWhitelistResponse200) & {
  headers: Headers;
};
;

export type plotAclGetWhitelistResponse = (plotAclGetWhitelistResponseSuccess)

export const getPlotAclGetWhitelistUrl = (botId: string,) => {




  return `/api/plotacl/${botId}/whitelist`
}

export const usePlotAclGetWhitelistHook = (): (botId: string, options?: RequestInit) => Promise<plotAclGetWhitelistResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string, options?: RequestInit) => {

        return customFetcher(getPlotAclGetWhitelistUrl(botId),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type plotAclAddWhitelistResponse200 = {
  data: ApiEnvelopePlotAclWhitelistDto
  status: 200
}

export type plotAclAddWhitelistResponseSuccess = (plotAclAddWhitelistResponse200) & {
  headers: Headers;
};
;

export type plotAclAddWhitelistResponse = (plotAclAddWhitelistResponseSuccess)

export const getPlotAclAddWhitelistUrl = (botId: string,) => {




  return `/api/plotacl/${botId}/whitelist`
}

export const usePlotAclAddWhitelistHook = (): (botId: string,
    plotAclWhitelistRequest?: PlotAclWhitelistRequest, options?: RequestInit) => Promise<plotAclAddWhitelistResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    plotAclWhitelistRequest?: PlotAclWhitelistRequest, options?: RequestInit) => {

        return customFetcher(getPlotAclAddWhitelistUrl(botId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(plotAclWhitelistRequest)
  }
);
      }
  }


export type plotAclRemoveWhitelistResponse200 = {
  data: ApiEnvelopePlotAclEmptyDto
  status: 200
}

export type plotAclRemoveWhitelistResponseSuccess = (plotAclRemoveWhitelistResponse200) & {
  headers: Headers;
};
;

export type plotAclRemoveWhitelistResponse = (plotAclRemoveWhitelistResponseSuccess)

export const getPlotAclRemoveWhitelistUrl = (botId: string,
    entryId: string,) => {




  return `/api/plotacl/${botId}/whitelist/${entryId}`
}

export const usePlotAclRemoveWhitelistHook = (): (botId: string,
    entryId: string, options?: RequestInit) => Promise<plotAclRemoveWhitelistResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    entryId: string, options?: RequestInit) => {

        return customFetcher(getPlotAclRemoveWhitelistUrl(botId,entryId),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type plotAclSetWhitelistNoteResponse200 = {
  data: ApiEnvelopePlotAclWhitelistDto
  status: 200
}

export type plotAclSetWhitelistNoteResponseSuccess = (plotAclSetWhitelistNoteResponse200) & {
  headers: Headers;
};
;

export type plotAclSetWhitelistNoteResponse = (plotAclSetWhitelistNoteResponseSuccess)

export const getPlotAclSetWhitelistNoteUrl = (botId: string,
    entryId: string,) => {




  return `/api/plotacl/${botId}/whitelist/${entryId}/note`
}

export const usePlotAclSetWhitelistNoteHook = (): (botId: string,
    entryId: string,
    plotAclNoteRequest?: PlotAclNoteRequest, options?: RequestInit) => Promise<plotAclSetWhitelistNoteResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    entryId: string,
    plotAclNoteRequest?: PlotAclNoteRequest, options?: RequestInit) => {

        return customFetcher(getPlotAclSetWhitelistNoteUrl(botId,entryId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(plotAclNoteRequest)
  }
);
      }
  }


export type plotAclAddRankExemptionResponse200 = {
  data: ApiEnvelopePlotAclRankExemptionDto
  status: 200
}

export type plotAclAddRankExemptionResponseSuccess = (plotAclAddRankExemptionResponse200) & {
  headers: Headers;
};
;

export type plotAclAddRankExemptionResponse = (plotAclAddRankExemptionResponseSuccess)

export const getPlotAclAddRankExemptionUrl = (botId: string,) => {




  return `/api/plotacl/${botId}/rank-exemptions`
}

export const usePlotAclAddRankExemptionHook = (): (botId: string,
    plotAclRankExemptionRequest?: PlotAclRankExemptionRequest, options?: RequestInit) => Promise<plotAclAddRankExemptionResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    plotAclRankExemptionRequest?: PlotAclRankExemptionRequest, options?: RequestInit) => {

        return customFetcher(getPlotAclAddRankExemptionUrl(botId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(plotAclRankExemptionRequest)
  }
);
      }
  }


export type plotAclRemoveRankExemptionResponse200 = {
  data: ApiEnvelopePlotAclEmptyDto
  status: 200
}

export type plotAclRemoveRankExemptionResponseSuccess = (plotAclRemoveRankExemptionResponse200) & {
  headers: Headers;
};
;

export type plotAclRemoveRankExemptionResponse = (plotAclRemoveRankExemptionResponseSuccess)

export const getPlotAclRemoveRankExemptionUrl = (botId: string,
    exemptionId: string,) => {




  return `/api/plotacl/${botId}/rank-exemptions/${exemptionId}`
}

export const usePlotAclRemoveRankExemptionHook = (): (botId: string,
    exemptionId: string, options?: RequestInit) => Promise<plotAclRemoveRankExemptionResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    exemptionId: string, options?: RequestInit) => {

        return customFetcher(getPlotAclRemoveRankExemptionUrl(botId,exemptionId),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type plotAclSetRankExemptionNoteResponse200 = {
  data: ApiEnvelopePlotAclRankExemptionDto
  status: 200
}

export type plotAclSetRankExemptionNoteResponseSuccess = (plotAclSetRankExemptionNoteResponse200) & {
  headers: Headers;
};
;

export type plotAclSetRankExemptionNoteResponse = (plotAclSetRankExemptionNoteResponseSuccess)

export const getPlotAclSetRankExemptionNoteUrl = (botId: string,
    exemptionId: string,) => {




  return `/api/plotacl/${botId}/rank-exemptions/${exemptionId}/note`
}

export const usePlotAclSetRankExemptionNoteHook = (): (botId: string,
    exemptionId: string,
    plotAclNoteRequest?: PlotAclNoteRequest, options?: RequestInit) => Promise<plotAclSetRankExemptionNoteResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    exemptionId: string,
    plotAclNoteRequest?: PlotAclNoteRequest, options?: RequestInit) => {

        return customFetcher(getPlotAclSetRankExemptionNoteUrl(botId,exemptionId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(plotAclNoteRequest)
  }
);
      }
  }


export type plotAclGetOverviewResponse200 = {
  data: ApiEnvelopePlotAclOverviewDto
  status: 200
}

export type plotAclGetOverviewResponseSuccess = (plotAclGetOverviewResponse200) & {
  headers: Headers;
};
;

export type plotAclGetOverviewResponse = (plotAclGetOverviewResponseSuccess)

export const getPlotAclGetOverviewUrl = (botId: string,) => {




  return `/api/plotacl/${botId}/overview`
}

export const usePlotAclGetOverviewHook = (): (botId: string, options?: RequestInit) => Promise<plotAclGetOverviewResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string, options?: RequestInit) => {

        return customFetcher(getPlotAclGetOverviewUrl(botId),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type plotAclAttachWhitelistListResponse200 = {
  data: ApiEnvelopePlotAclEmptyDto
  status: 200
}

export type plotAclAttachWhitelistListResponseSuccess = (plotAclAttachWhitelistListResponse200) & {
  headers: Headers;
};
;

export type plotAclAttachWhitelistListResponse = (plotAclAttachWhitelistListResponseSuccess)

export const getPlotAclAttachWhitelistListUrl = (botId: string,
    playerListId: string,) => {




  return `/api/plotacl/${botId}/whitelist/lists/${playerListId}`
}

export const usePlotAclAttachWhitelistListHook = (): (botId: string,
    playerListId: string, options?: RequestInit) => Promise<plotAclAttachWhitelistListResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    playerListId: string, options?: RequestInit) => {

        return customFetcher(getPlotAclAttachWhitelistListUrl(botId,playerListId),
  {
    ...options,
    method: 'POST'


  }
);
      }
  }


export type plotAclDetachWhitelistListResponse200 = {
  data: ApiEnvelopePlotAclEmptyDto
  status: 200
}

export type plotAclDetachWhitelistListResponseSuccess = (plotAclDetachWhitelistListResponse200) & {
  headers: Headers;
};
;

export type plotAclDetachWhitelistListResponse = (plotAclDetachWhitelistListResponseSuccess)

export const getPlotAclDetachWhitelistListUrl = (botId: string,
    playerListId: string,) => {




  return `/api/plotacl/${botId}/whitelist/lists/${playerListId}`
}

export const usePlotAclDetachWhitelistListHook = (): (botId: string,
    playerListId: string, options?: RequestInit) => Promise<plotAclDetachWhitelistListResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    playerListId: string, options?: RequestInit) => {

        return customFetcher(getPlotAclDetachWhitelistListUrl(botId,playerListId),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type plotAclAttachBanListResponse200 = {
  data: ApiEnvelopePlotAclEmptyDto
  status: 200
}

export type plotAclAttachBanListResponseSuccess = (plotAclAttachBanListResponse200) & {
  headers: Headers;
};
;

export type plotAclAttachBanListResponse = (plotAclAttachBanListResponseSuccess)

export const getPlotAclAttachBanListUrl = (botId: string,
    playerListId: string,) => {




  return `/api/plotacl/${botId}/bans/lists/${playerListId}`
}

export const usePlotAclAttachBanListHook = (): (botId: string,
    playerListId: string, options?: RequestInit) => Promise<plotAclAttachBanListResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    playerListId: string, options?: RequestInit) => {

        return customFetcher(getPlotAclAttachBanListUrl(botId,playerListId),
  {
    ...options,
    method: 'POST'


  }
);
      }
  }


export type plotAclDetachBanListResponse200 = {
  data: ApiEnvelopePlotAclEmptyDto
  status: 200
}

export type plotAclDetachBanListResponseSuccess = (plotAclDetachBanListResponse200) & {
  headers: Headers;
};
;

export type plotAclDetachBanListResponse = (plotAclDetachBanListResponseSuccess)

export const getPlotAclDetachBanListUrl = (botId: string,
    playerListId: string,) => {




  return `/api/plotacl/${botId}/bans/lists/${playerListId}`
}

export const usePlotAclDetachBanListHook = (): (botId: string,
    playerListId: string, options?: RequestInit) => Promise<plotAclDetachBanListResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    playerListId: string, options?: RequestInit) => {

        return customFetcher(getPlotAclDetachBanListUrl(botId,playerListId),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type plotAclAttachRankExemptionListResponse200 = {
  data: ApiEnvelopePlotAclEmptyDto
  status: 200
}

export type plotAclAttachRankExemptionListResponseSuccess = (plotAclAttachRankExemptionListResponse200) & {
  headers: Headers;
};
;

export type plotAclAttachRankExemptionListResponse = (plotAclAttachRankExemptionListResponseSuccess)

export const getPlotAclAttachRankExemptionListUrl = (botId: string,
    playerListId: string,) => {




  return `/api/plotacl/${botId}/rank-exemptions/lists/${playerListId}`
}

export const usePlotAclAttachRankExemptionListHook = (): (botId: string,
    playerListId: string, options?: RequestInit) => Promise<plotAclAttachRankExemptionListResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    playerListId: string, options?: RequestInit) => {

        return customFetcher(getPlotAclAttachRankExemptionListUrl(botId,playerListId),
  {
    ...options,
    method: 'POST'


  }
);
      }
  }


export type plotAclDetachRankExemptionListResponse200 = {
  data: ApiEnvelopePlotAclEmptyDto
  status: 200
}

export type plotAclDetachRankExemptionListResponseSuccess = (plotAclDetachRankExemptionListResponse200) & {
  headers: Headers;
};
;

export type plotAclDetachRankExemptionListResponse = (plotAclDetachRankExemptionListResponseSuccess)

export const getPlotAclDetachRankExemptionListUrl = (botId: string,
    playerListId: string,) => {




  return `/api/plotacl/${botId}/rank-exemptions/lists/${playerListId}`
}

export const usePlotAclDetachRankExemptionListHook = (): (botId: string,
    playerListId: string, options?: RequestInit) => Promise<plotAclDetachRankExemptionListResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    playerListId: string, options?: RequestInit) => {

        return customFetcher(getPlotAclDetachRankExemptionListUrl(botId,playerListId),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type plotAclAttachAccessListResponse200 = {
  data: ApiEnvelopePlotAclEmptyDto
  status: 200
}

export type plotAclAttachAccessListResponseSuccess = (plotAclAttachAccessListResponse200) & {
  headers: Headers;
};
;

export type plotAclAttachAccessListResponse = (plotAclAttachAccessListResponseSuccess)

export const getPlotAclAttachAccessListUrl = (botId: string,
    plotId: string,
    playerListId: string,) => {




  return `/api/plotacl/${botId}/plots/${plotId}/access/lists/${playerListId}`
}

export const usePlotAclAttachAccessListHook = (): (botId: string,
    plotId: string,
    playerListId: string, options?: RequestInit) => Promise<plotAclAttachAccessListResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    plotId: string,
    playerListId: string, options?: RequestInit) => {

        return customFetcher(getPlotAclAttachAccessListUrl(botId,plotId,playerListId),
  {
    ...options,
    method: 'POST'


  }
);
      }
  }


export type plotAclDetachAccessListResponse200 = {
  data: ApiEnvelopePlotAclEmptyDto
  status: 200
}

export type plotAclDetachAccessListResponseSuccess = (plotAclDetachAccessListResponse200) & {
  headers: Headers;
};
;

export type plotAclDetachAccessListResponse = (plotAclDetachAccessListResponseSuccess)

export const getPlotAclDetachAccessListUrl = (botId: string,
    plotId: string,
    playerListId: string,) => {




  return `/api/plotacl/${botId}/plots/${plotId}/access/lists/${playerListId}`
}

export const usePlotAclDetachAccessListHook = (): (botId: string,
    plotId: string,
    playerListId: string, options?: RequestInit) => Promise<plotAclDetachAccessListResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    plotId: string,
    playerListId: string, options?: RequestInit) => {

        return customFetcher(getPlotAclDetachAccessListUrl(botId,plotId,playerListId),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type plotAclUpdatePlotSettingsResponse200 = {
  data: ApiEnvelopePlotAclPlotDto
  status: 200
}

export type plotAclUpdatePlotSettingsResponseSuccess = (plotAclUpdatePlotSettingsResponse200) & {
  headers: Headers;
};
;

export type plotAclUpdatePlotSettingsResponse = (plotAclUpdatePlotSettingsResponseSuccess)

export const getPlotAclUpdatePlotSettingsUrl = (botId: string,
    plotId: string,) => {




  return `/api/plotacl/${botId}/plots/${plotId}/settings`
}

export const usePlotAclUpdatePlotSettingsHook = (): (botId: string,
    plotId: string,
    plotAclPlotSettingsRequest?: PlotAclPlotSettingsRequest, options?: RequestInit) => Promise<plotAclUpdatePlotSettingsResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    plotId: string,
    plotAclPlotSettingsRequest?: PlotAclPlotSettingsRequest, options?: RequestInit) => {

        return customFetcher(getPlotAclUpdatePlotSettingsUrl(botId,plotId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(plotAclPlotSettingsRequest)
  }
);
      }
  }


export type plotAclAddPlotAccessResponse200 = {
  data: ApiEnvelopePlotAclAccessEntryDto
  status: 200
}

export type plotAclAddPlotAccessResponseSuccess = (plotAclAddPlotAccessResponse200) & {
  headers: Headers;
};
;

export type plotAclAddPlotAccessResponse = (plotAclAddPlotAccessResponseSuccess)

export const getPlotAclAddPlotAccessUrl = (botId: string,
    plotId: string,) => {




  return `/api/plotacl/${botId}/plots/${plotId}/access`
}

export const usePlotAclAddPlotAccessHook = (): (botId: string,
    plotId: string,
    plotAclAccessRequest?: PlotAclAccessRequest, options?: RequestInit) => Promise<plotAclAddPlotAccessResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    plotId: string,
    plotAclAccessRequest?: PlotAclAccessRequest, options?: RequestInit) => {

        return customFetcher(getPlotAclAddPlotAccessUrl(botId,plotId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(plotAclAccessRequest)
  }
);
      }
  }


export type plotAclRemovePlotAccessResponse200 = {
  data: ApiEnvelopePlotAclEmptyDto
  status: 200
}

export type plotAclRemovePlotAccessResponseSuccess = (plotAclRemovePlotAccessResponse200) & {
  headers: Headers;
};
;

export type plotAclRemovePlotAccessResponse = (plotAclRemovePlotAccessResponseSuccess)

export const getPlotAclRemovePlotAccessUrl = (botId: string,
    plotId: string,
    entryId: string,) => {




  return `/api/plotacl/${botId}/plots/${plotId}/access/${entryId}`
}

export const usePlotAclRemovePlotAccessHook = (): (botId: string,
    plotId: string,
    entryId: string, options?: RequestInit) => Promise<plotAclRemovePlotAccessResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    plotId: string,
    entryId: string, options?: RequestInit) => {

        return customFetcher(getPlotAclRemovePlotAccessUrl(botId,plotId,entryId),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type plotAclSetPlotAccessNoteResponse200 = {
  data: ApiEnvelopePlotAclAccessEntryDto
  status: 200
}

export type plotAclSetPlotAccessNoteResponseSuccess = (plotAclSetPlotAccessNoteResponse200) & {
  headers: Headers;
};
;

export type plotAclSetPlotAccessNoteResponse = (plotAclSetPlotAccessNoteResponseSuccess)

export const getPlotAclSetPlotAccessNoteUrl = (botId: string,
    plotId: string,
    entryId: string,) => {




  return `/api/plotacl/${botId}/plots/${plotId}/access/${entryId}/note`
}

export const usePlotAclSetPlotAccessNoteHook = (): (botId: string,
    plotId: string,
    entryId: string,
    plotAclNoteRequest?: PlotAclNoteRequest, options?: RequestInit) => Promise<plotAclSetPlotAccessNoteResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    plotId: string,
    entryId: string,
    plotAclNoteRequest?: PlotAclNoteRequest, options?: RequestInit) => {

        return customFetcher(getPlotAclSetPlotAccessNoteUrl(botId,plotId,entryId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(plotAclNoteRequest)
  }
);
      }
  }


export type plotAclRemovePlotResponse200 = {
  data: ApiEnvelopePlotAclEmptyDto
  status: 200
}

export type plotAclRemovePlotResponseSuccess = (plotAclRemovePlotResponse200) & {
  headers: Headers;
};
;

export type plotAclRemovePlotResponse = (plotAclRemovePlotResponseSuccess)

export const getPlotAclRemovePlotUrl = (botId: string,
    plotId: string,) => {




  return `/api/plotacl/${botId}/plots/${plotId}`
}

export const usePlotAclRemovePlotHook = (): (botId: string,
    plotId: string, options?: RequestInit) => Promise<plotAclRemovePlotResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    plotId: string, options?: RequestInit) => {

        return customFetcher(getPlotAclRemovePlotUrl(botId,plotId),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


